import { render, staticRenderFns } from "./fixedTop.vue?vue&type=template&id=23062804&"
import script from "./fixedTop.vue?vue&type=script&lang=ts&"
export * from "./fixedTop.vue?vue&type=script&lang=ts&"
import style0 from "./fixedTop.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports